import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=33ca4a30&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=33ca4a30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca4a30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ca4a30')) {
      api.createRecord('33ca4a30', component.options)
    } else {
      api.reload('33ca4a30', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=33ca4a30&scoped=true", function () {
      api.rerender('33ca4a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/reunionDinnerManagement/reunionPreOrderManagement/detail.vue"
export default component.exports